export default __webpack_public_path__ + "static/media/R5C_8162.2481f3e7.jpg";